import { render, staticRenderFns } from "./claimsList.vue?vue&type=template&id=aeecb7f4"
import script from "./claimsList.vue?vue&type=script&lang=js"
export * from "./claimsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports